export const GET_PRODUCTS_SMARTPHONE_LOADING = "products/get/smartphone/loading"
export const GET_PRODUCTS_SMARTPHONE_ERROR = "products/get/smartphone/error"
export const GET_PRODUCTS_SMARTPHONE_SUCCESS = "products/get/smartphone/success"

export const GET_PRODUCTS_TV_LOADING = "products/get/tv/loading"
export const GET_PRODUCTS_TV_ERROR = "products/get/tv/error"
export const GET_PRODUCTS_TV_SUCCESS = "products/get/tv/success"



export const GET_PRODUCTS_WASHINGMACHINE_LOADING = "products/get/washingMachine/loading"
export const GET_PRODUCTS_WASHINGMACHINE_ERROR = "products/get/washingMachine/error"
export const GET_PRODUCTS_WASHINGMACHINE_SUCCESS = "products/get/washingMachine/success"


export const GET_PRODUCTS_WATCHES_LOADING = "products/get/watches/loading"
export const GET_PRODUCTS_WATCHES_ERROR = "products/get/watches/error"
export const GET_PRODUCTS_WATCHES_SUCCESS = "products/get/watches/success"




export const GET_PRODUCTS_HEADPHONES_LOADING = "products/get/headphones/loading"
export const GET_PRODUCTS_HEADPHONES_ERROR = "products/get/headphones/error"
export const GET_PRODUCTS_HEADPHONES_SUCCESS = "products/get/headphones/success"




export const GET_PRODUCTS_AC_LOADING = "products/get/ac/loading"
export const GET_PRODUCTS_AC_ERROR = "products/get/ac/error"
export const GET_PRODUCTS_AC_SUCCESS = "products/get/ac/success"

